/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Offline_Leave_BodyInputs */



/**
* | output |
* | --- |
* | "If you leave this page, the recording stops. Wundo then writes the report from what has been recorded so far." |
*
* @param {Meeting_Offline_Leave_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_offline_leave_body = /** @type {((inputs?: Meeting_Offline_Leave_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Offline_Leave_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Als je deze pagina verlaat, stopt de opname. Wundo maakt dan het verslag van wat er al opgenomen is.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Si vous quittez cette page, l'enregistrement s'arrête. Wundo rédige alors le compte rendu à partir de ce qui a déjà été enregistré.")
	return /** @type {LocalizedString} */ ("If you leave this page, the recording stops. Wundo then writes the report from what has been recorded so far.")
});